export default "__VITE_ASSET__CsP$SURK__"